import React, { useState, useEffect } from "react";
import useHtmlToText from "../../../../Company/Component/CustomHooks/convertHtmlToText";
import dummyCompanyLogo from "../../../../assets/postJob.png";
import { FaArrowLeftLong } from "react-icons/fa6";
import { PiArrowUpRightBold } from "react-icons/pi";
import { TiLocation } from "react-icons/ti";
import { IoMdShare } from "react-icons/io";
import { FiBookmark } from "react-icons/fi";
import { FaBookmark } from "react-icons/fa";
import bagImage from "../../../../assets/bag-solid.png";
import cashMultiple from "../../../../assets/cash-multiple.png";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { URLS } from "../../../../Utils/App_urls";
import {
  errorPopup,
  successPopup,
  warningPopup,
} from "../../../../Utils/ToasterMessage";
import { getJobPostedDate } from "../../../../Company/Component/CustomHook/jobPostedDate";

import {
  EventButton,
  StepperBackButton,
} from "../../../component/ReUseComps/Button";
import Loader from "../../../component/Loader/Loader";
import "./JobDetails.css";

const formatDisplayUrl = (url) => {
  if (!url) return "N/A";
  try {
    const urlObj = new URL(url.startsWith("http") ? url : `https://${url}`);
    return urlObj.hostname.replace(/^www\./i, "");
  } catch {
    return (
      url
        .replace(/^https?:\/\//i, "")
        .replace(/^www\./i, "")
        .split("/")[0] || "N/A"
    );
  }
};

export default function JobDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const jobId = location?.state?.DATA;
  const paramsId = useParams();
  const [singleJobDetails, setSingleJobDetails] = useState({});
  const [isSaveForLater, setIsSaveForLater] = useState(false);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const convertedJobDescription = useHtmlToText(
    singleJobDetails?.jobDescription
  );

  const getSingleJobDetails = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${URLS.getSingleJob}`, {
        params: { id: jobId },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });

      const result = res?.data?.result?.[0] || {};
      console.log("get meri job detail", result);
      setSingleJobDetails(result);
      setIsSaveForLater(result?.savedLaterJobs?.status || false);
    } catch (err) {
      errorPopup(err?.response?.data?.message || "Failed to load job details");
    } finally {
      setLoading(false);
    }
  };

  const applyJob = async () => {
    try {
      await axios.post(
        `${URLS.userJobApplie}`,
        { JobId: jobId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      successPopup("Application submitted successfully");
      getSingleJobDetails();
    } catch (err) {
      errorPopup(err?.response?.data?.message || "Failed to apply");
    }
  };

  const toggleSaveJob = async () => {
    if (actionLoading) return;

    setActionLoading(true);
    try {
      const newStatus = !isSaveForLater;
      await axios.post(
        `${URLS.saveLater}`,
        { JobId: jobId, status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      );
      setIsSaveForLater(newStatus);
      successPopup(
        newStatus ? "Job saved successfully" : "Job removed from saved list"
      );
    } catch (err) {
      errorPopup(
        err?.response?.data?.message || "Failed to update saved status"
      );
    } finally {
      setActionLoading(false);
    }
  };

  const shareLink = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: singleJobDetails?.title || "Job opportunity",
          text: "Check out this job posting:",
          url: window.location.href,
        });
      } else {
        await navigator.clipboard.writeText(window.location.href);
        successPopup("Link copied to clipboard!");
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        errorPopup("Failed to share: " + err.message);
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (!token) {
      navigate("/user/find-job");
      return;
    }
    getSingleJobDetails();
  }, [paramsId?.id]);

  const formatWebsiteUrl = (url) => {
    return url?.startsWith("http") ? url : url ? `https://${url}` : "#";
  };

  if (loading) return <Loader />;

  return (
    <div className="job-details-main find_jobDetails_jobs w-100">
      {(location.pathname.includes("notIntested-jobs") ||
        location.pathname.includes("savedJobs")) && (
        <h1 className="backCondiationaly mb-3" onClick={() => navigate(-1)}>
          <FaArrowLeftLong fontSize={20} /> Job Details
        </h1>
      )}

      <div className="similar-job-card d-flex flex-column gap-1">
        <div className="similar-job-header d-flex flex-sm-row flex-column-reverse align-items-start justify-content-between flex-wrap gap-1">
          <div className="d-flex align-items-center gap-1">
            <div className="compy-logo-box">
              <img
                src={
                  singleJobDetails?.companyProfileDetail?.[0]?.companylogo ||
                  dummyCompanyLogo
                }
                alt="Company logo"
                onError={(e) => {
                  e.target.src = dummyCompanyLogo;
                }}
              />
            </div>
            <div className="compy-title-descr">
              <h1>{singleJobDetails?.title || "N/A"}</h1>
              <p>
                {singleJobDetails?.companyProfileDetail?.[0]?.companyName ||
                  "N/A"}
              </p>
              <a
                href={formatWebsiteUrl(
                  singleJobDetails?.companyProfileDetail?.[0]?.weburl
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                {formatDisplayUrl(
                  singleJobDetails?.companyProfileDetail?.[0]?.weburl
                )}
              </a>
            </div>
          </div>
          <p className="m-0">
            {getJobPostedDate(singleJobDetails?.createdAt?.split("T"))}
          </p>
        </div>

        <div className="compay-benif d-flex align-items-start justify-content-start flex-wrap gap-1">
          <div>
            <img src={bagImage} alt="Experience icon" />
            <span>{singleJobDetails?.experience || "Not specified"}</span>
          </div>
          {singleJobDetails?.salaryType === "Fixed Salary" && (
            <div>
              <img src={cashMultiple} alt="Salary icon" />
              <span>{singleJobDetails?.FixedSalary}LPA</span>
            </div>
          )}
          {singleJobDetails?.salaryType === "Salary Range" && (
            <div>
              <img src={cashMultiple} alt="Salary icon" />
              <span>
                {singleJobDetails?.minSalary} - {singleJobDetails?.maxSalary}LPA
              </span>
            </div>
          )}
          {singleJobDetails?.salaryType === "Not Disclose" && (
            <div>
              <img src={cashMultiple} alt="Salary icon" />
              <span>Not disclosed</span>
            </div>
          )}
          <div>
            <TiLocation color="#4B4B4B" fontSize={20} />
            <span>
              {singleJobDetails?.jobLocations || "Location not specified"}
            </span>
          </div>
        </div>

        <div className="highlight-skills d-flex align-items-center flex-wrap gap-1">
          <div>{singleJobDetails?.deparmentType || "N/A"}</div>
          <div>{singleJobDetails?.workPlace || "N/A"}</div>
          <div>{singleJobDetails?.shift || "N/A"}</div>
        </div>

        <div className="skill-section-job-card d-flex align-items-center flex-wrap gap-1">
          {singleJobDetails?.skills?.map((data, index) => (
            <div key={index}>{data}</div>
          )) || <div>No skills specified</div>}
        </div>

        <div className="button-section-jobCard d-flex flex-wrap gap-1">
          {!singleJobDetails?.isUserApplied ? (
            <EventButton onClick={applyJob}>
              <span>Apply Now </span>
              <PiArrowUpRightBold fontSize={22} />
            </EventButton>
          ) : (
            <EventButton className="applied-btn" disabled>
              <span>Applied</span>
            </EventButton>
          )}

          <StepperBackButton onClick={toggleSaveJob} disabled={actionLoading}>
            {actionLoading ? (
              <Spinner
                size="sm"
                animation="border"
                style={{
                  width: "15px",
                  height: "15px",
                  borderWidth: "2px",
                  marginRight: "2px",
                }}
              />
            ) : (
              <>
                {isSaveForLater ? "Saved" : "Save for Later"}
                {isSaveForLater ? (
                  <FaBookmark fontSize={18} />
                ) : (
                  <FiBookmark fontSize={18} />
                )}
              </>
            )}
          </StepperBackButton>

          <StepperBackButton onClick={shareLink}>
            Share <IoMdShare fontSize={18} />
          </StepperBackButton>
        </div>

        <div className="job-description-container sum_bg_remove mt-1">
          <h1>Job Description</h1>

          <div
            dangerouslySetInnerHTML={{
              __html:
                convertedJobDescription || "<p>No job description provided</p>",
            }}
          />
        </div>
      </div>
    </div>
  );
}
